import React from "react";

// Hand-drawn-feeling orbital ecosystem SVG
// Uses muted ink with bronze accents on a transparent background.
export const OrbitalDiagram = ({ className = "", strokeColor = "#2A2A2A", accentColor = "#8C6A48" }) => {
  return (
    <svg
      viewBox="0 0 600 600"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Orbital ecosystem illustration"
    >
      <defs>
        <filter id="grain" x="0" y="0" width="100%" height="100%">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" />
          <feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.08 0" />
        </filter>
      </defs>

      {/* slow rotating orbit group */}
      <g className="orbit-spin" style={{ transformOrigin: "300px 300px" }}>
        {/* outer dashed orbit */}
        <ellipse
          cx="300"
          cy="300"
          rx="260"
          ry="240"
          fill="none"
          stroke={strokeColor}
          strokeWidth="0.5"
          strokeDasharray="2 4"
          opacity="0.6"
        />
        {/* second orbit, tilted */}
        <ellipse
          cx="300"
          cy="300"
          rx="220"
          ry="180"
          fill="none"
          stroke={strokeColor}
          strokeWidth="0.5"
          opacity="0.5"
          transform="rotate(-20 300 300)"
        />
        {/* inner orbit */}
        <ellipse
          cx="300"
          cy="300"
          rx="160"
          ry="140"
          fill="none"
          stroke={strokeColor}
          strokeWidth="0.5"
          strokeDasharray="1 3"
          opacity="0.7"
          transform="rotate(15 300 300)"
        />

        {/* nodes on orbits */}
        <circle cx="60" cy="300" r="3" fill={accentColor} />
        <circle cx="540" cy="290" r="2.5" fill={strokeColor} opacity="0.6" />
        <circle cx="140" cy="180" r="2" fill={strokeColor} opacity="0.6" />
        <circle cx="450" cy="430" r="2.5" fill={accentColor} />
        <circle cx="310" cy="60" r="2" fill={strokeColor} opacity="0.5" />
        <circle cx="290" cy="540" r="2" fill={strokeColor} opacity="0.5" />
      </g>

      {/* central drawn brushstroke moon */}
      <g>
        <circle cx="300" cy="300" r="80" fill="#EFECE5" stroke={strokeColor} strokeWidth="0.6" opacity="0.9" />
        <g opacity="0.45">
          <path
            d="M 240 290 Q 270 250 320 270 T 360 320 Q 340 360 290 350 T 240 290 Z"
            fill={strokeColor}
            opacity="0.18"
          />
          <path
            d="M 260 320 Q 290 300 320 320 T 340 340"
            fill="none"
            stroke={strokeColor}
            strokeWidth="0.6"
          />
          <path
            d="M 270 280 Q 300 270 330 290"
            fill="none"
            stroke={strokeColor}
            strokeWidth="0.5"
          />
        </g>
        <circle cx="300" cy="300" r="80" fill="url(#grain)" opacity="0.7" />
      </g>

      {/* small satellite */}
      <g>
        <circle cx="180" cy="160" r="14" fill="none" stroke={strokeColor} strokeWidth="0.6" opacity="0.5" />
        <circle cx="180" cy="160" r="3" fill={strokeColor} opacity="0.7" />
      </g>

      {/* corner small ring */}
      <g>
        <circle cx="470" cy="200" r="20" fill="none" stroke={strokeColor} strokeWidth="0.6" opacity="0.45" />
      </g>

      {/* hand-drawn looping lines */}
      <path
        d="M 100 460 C 200 420, 250 500, 350 470 S 500 420, 540 470"
        fill="none"
        stroke={strokeColor}
        strokeWidth="0.5"
        opacity="0.35"
      />
      <path
        d="M 80 120 C 160 80, 240 140, 320 110"
        fill="none"
        stroke={strokeColor}
        strokeWidth="0.5"
        opacity="0.3"
      />
    </svg>
  );
};

export default OrbitalDiagram;
